import React from 'react';
import { styled } from '@mui/material/styles';
import { OrderedQuestionEntry, splitQuestionLinks } from './workspaceDerivations';
import { ACCENT_BLUE, ACCENT_BLUE_DARK } from './qcTheme';

const QuestionLink = styled('button')({
  border: 'none',
  background: 'none',
  padding: 0,
  fontFamily: 'inherit',
  fontSize: 'inherit',
  color: ACCENT_BLUE,
  fontWeight: 600,
  cursor: 'pointer',
  '&:hover': {
    color: ACCENT_BLUE_DARK,
    textDecoration: 'underline',
  },
});

export default function LinkedText({ text, entries, onNavigateToCode }: {
  text: string;
  entries: OrderedQuestionEntry[];
  onNavigateToCode: (shortCode: string) => void;
}): JSX.Element {
  // Character offsets make stable keys — parts never reorder within a text.
  let offset = 0;
  const nodes = splitQuestionLinks(text, entries).map(part => {
    const key = `at-${offset}`;
    offset += part.text.length;
    if (!part.shortCode) return <React.Fragment key={key}>{part.text}</React.Fragment>;
    const { shortCode } = part;
    return (
      <QuestionLink key={key} type='button' title='Go to this question' onClick={() => onNavigateToCode(shortCode)}>
        {part.text}
      </QuestionLink>
    );
  });
  return <>{nodes}</>;
}
